// extracted by mini-css-extract-plugin
module.exports = {"title":"_2lAUHq","uppercase":"_1HbGV1","active":"zCjHpQ","icon":"_3gh6bx"};